<template>
    <div id="customerkpi">

        <div kpi-item v-for="(d,index) in kData">
            <div title>{{d.KpiKey}}</div>
            <div content>
                <div citem v-for="(it,idx) in d.KpiList">
                    <div itemct>
                        <div>{{it.KpiValue}}</div>
                        <div>{{it.KpiKey}}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import { getBaseUrl, GetCustomerKpi } from "../../api/api";

    export default {
        data() {
            return {
                baseUrl: getBaseUrl(),
                curCid: this.$route.params.cid,
                kData: {},
            };
        },
        mounted() {
            this.getCustomerKpiData();
        },
        methods: {
            getCustomerKpiData() {
                GetCustomerKpi({ CustomerId: this.curCid }).then(res => {
                    if (res.data.Code != 1) this.$message.error(res.data.Message);
                    this.kData = res.data.Data;
                });
            }
        },
    };
</script>

<style scoped>
    #customerkpi {
        padding: 12px;
    }

    [kpi-item] {
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
    }

    [title] {
        color: #10A54A;
    }

    [content] {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;
        margin-bottom: 25px;
    margin-top: 15px;
    }

    [citem] {
        box-sizing: border-box;
        background-color: white;
        flex: 0 0 33%;
        text-align: center;
        margin-bottom: 10px;
    }

    [itemct] {
        /* background: #ddd; */
    }

    [itemct]>>>div {
        font-size: 13px;
        max-width: 60%;
        text-align: center;
        margin: 0 auto;
        color: #aaa;
    }

    [itemct]>>>div:first-child {
        font-size: 12px;
        line-height: 30px;
        max-width: 60%;
        text-align: center;
        margin: 0 auto;
        color: #aaa;
    }

</style>


// WEBPACK FOOTER //
// src/components/kpi/CustomerKpi.vue